export default __webpack_public_path__ + "static/media/logo.db8963a5.png";